module.exports = __webpack_public_path__ + "img/kfewm.c3e6f4a8.png";